import React, {useState} from 'react';
import styles from './styles';
import axios from 'axios'
import axiosConfig from '../../../../config/axios.config'
import {Icons, IconButton} from '@xpertdox_js/xdcomponents';
import {btn_c_clearToShade, clearfix, absCenter} from '@xpertdox_js/xdstyle';
import { trackActivity, trackError } from '../../../../utils/activityTracker'
import { UserContext } from '../../../../Context/UserContext'
import { InstanceContext } from '../../../../InstanceContext'

const SidePanel = props => {
  // const {auth} = props.context;
  const {trials} = props;
  const { user, userAction } = React.useContext(UserContext)
  const { contextInstance } = React.useContext(InstanceContext)

  const handleActivityLogUpdate = (_id) => {
    trackActivity({
      body: {
        _id,
        instance: contextInstance || user.instance,
        user: user.id
      }
    })
  }

  const trialClick = (e,t) => {
    handleActivityLogUpdate(`SidePanel.trialClick`)
    const allNcts = [];
    trials && trials.forEach(trial => {
      allNcts.push(trial.trial._id._id);
    });
    props.history.push({
      pathname: `/${t.instance}/trials/overview/${t.trial._id._id}`,
      state: { auth: user, addTrials: true, allNcts}
    })
  }

  const noTrialsAdded = trials && trials.length === 0;

  const handleTrialRemoval = (id) => {
      let body = {
        instance: props.context.instance,
        ncts: [id]
      }
    // removed 'axiosConfig.auth' as token is updated on login
    axios.post(`${axiosConfig.apiUrl}/rt/console/deleteAdded/${user.email}`, body).then(res =>{
      props.fetchTrials()
    })
    .catch((err) =>{
      console.log(err)
      trackError({ error: err, history: props.history })
      if (err && err.response && err.response.status === 403) {
        userAction({type: 'logout'})
      }
    })
  }

  return (
    <div style={styles.sidePanel}>
      <h4 style={styles.title}>{noTrialsAdded ? 'No Trials Added' : 'Added Trials'}</h4>
      {!noTrialsAdded && trials &&
        <div style={styles.trialsContainer}>
        {trials.map((t,i)=>{
          return (
            <div onClick={e => trialClick(e,t)} key={i} style={styles.trialBlock}>
              <div style={clearfix}>
                <div style={styles.trialContent}>
                  <p style={styles.trialText}><b>{t.trial._id._id}</b></p>
                  <p style={styles.trialText}>Added: {t.created_date}</p>
                  <p style={styles.trialText}>{t.trial._id.brief_title.substring(0,31)+'...'}</p>
                </div>
                <div style={styles.trialControls}>
                  <IconButton
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      handleTrialRemoval(t.trial._id._id)
                    }}
                    icon='trash'
                    size='md'
                    styles={absCenter}
                    preBuiltStyles={btn_c_clearToShade}
                  />
                </div>
              </div>
            </div>
          )
        })}

        </div>
      }
    </div>
  )
}

export default SidePanel;
